// MASTERY-CLIENT-MIRROR-APPLIED: client-side mirror of the backend POINTS_BY_MARKS
// table so the UI can show "+3 pts" instantly without waiting for the backend
// response. MUST stay in sync with samajh-backend-main/mastery/mastery-config.js.
// If the backend table changes, update this file too.

export const POINTS_BY_MARKS = {
  1: { firstTry: 3,  secondTry: 1 },
  2: { firstTry: 5,  secondTry: 2 },
  3: { firstTry: 8,  secondTry: 4 },
  4: { firstTry: 9,  secondTry: 4 },
  5: { firstTry: 11, secondTry: 5 },
};

// Compute points for display. Returns 0 for wrong answers or invalid input.
export function pointsForAttempt(marks, isCorrect, attemptNumber = 1) {
  if (!isCorrect) return 0;
  const cfg = POINTS_BY_MARKS[Number(marks)];
  if (!cfg) return 0;
  return attemptNumber === 1 ? cfg.firstTry : cfg.secondTry;
}
